import { useContext } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import InventoryContext from '~/contexts/InventoryContext';
import type { Pagination } from '~/contracts';

type IncrementType = 'add' | 'custom' | 'end' | 'subtract' | 'start';

export default function usePagination(): {
  pagination: Partial<Pagination>;
  updatePagination: (
    incrementType: IncrementType,
    customNumber?: number
  ) => void;
} {
  const { pageNumber, setPageNumber } = useContext(AppliedFiltersContext);
  const {
    inventory: {
      data: { inventory }
    }
  } = useContext(InventoryContext);

  const pagination = { ...inventory.pagination, currentPage: pageNumber };

  const update = (incrementType: IncrementType, customNumber?: number) => {
    const {
      currentPage: inventoryCurrentPage = 1,
      totalMatchedPages: inventoryTotalMatchedPages = 1
    } = pagination;

    const page = {
      add: inventoryCurrentPage + 1,
      custom: customNumber ?? 1,
      subtract: inventoryCurrentPage - 1,
      end: inventoryTotalMatchedPages,
      start: 1
    };

    setPageNumber(page[incrementType]);
  };

  return { pagination, updatePagination: update };
}
